import * as React from 'react';
import { View, Text, Modal } from 'react-native';
import { Icon } from 'react-native-elements';
import useMediumScreen from 'hooks/useMediumScreen';
import VerificationModalProps from 'types/components/VerificationModalProps';
import VerificationCodeForm from 'forms/VerificationCodeForm';
import { styles } from 'styles/components/verificationModal';

export default ({ title, visible, setVisible, onHandleModal, error, generalColor }: VerificationModalProps): JSX.Element => {
  const mediumScreen = useMediumScreen();

  return (
    <Modal visible={visible} transparent={true} style={styles.modal}>
      <View style={styles.container}></View>
      <View style={styles.modalBox}>
        <View style={mediumScreen ? styles.modalContentLarge : styles.modalContentSmall}>
        <View style={[styles.modaIconContainer, { backgroundColor: generalColor ?? "#FFFFFF" }]}>
          <Icon 
           name={"alert-circle-outline"}
           type={"ionicon"}
           color={"#FFFFFF"}
           size={40}
           containerStyle={styles.iconContainer}
         />
        </View>
        <View style={styles.modalTextContainer}>
          <Text style={styles.modalText}>{title}</Text>
        </View>
          {error ? <Text style={styles.errorText}>{error}</Text> : <></>}
          <VerificationCodeForm onConfirm={onHandleModal} onCancel={() => setVisible(false)} generalColor={generalColor} />
        </View>
      </View>
    </Modal>
  );
};
